//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "AddNewAccessPermissionModal",
    components: {
        AQModal,
        AQCard,
        AQDropdown,
        AQRadio,
        AQDialog,
        AQCheckbox
    },
    props: {
        isEditPermission: { type: Boolean, default: false },
        editDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            addPermissionsModal: false,
            searchAppValue: "",
            appsPayload: {
                page: 0,
                search: "",
                ids: [],
                archived: false
            },
            applicationsOptions: [],
            appsMod: [],
            selectedOption: false,
            selectedPermissions: {},
            showError: false,
            dataAccessValue: "VIEW",
            showDialog: false,
            permissionListModified: false,
            viewDataAudit: false
        };
    },
    validations: {
        value: {
            required(v) {
                return !!(v && v.length);
            }
        }
    },
    computed: {
        hasSave() {
            return {
                label: this.$t("generic.done")
            };
        },
        getAllApplicationsProps() {
            return {
                placeholder: this.$t("appSetPermissions.placeholderApp"),
                options: this.applicationsOptions,
                addSearch: true,
                hasPagination: true
            };
        },
        errorLabelDDl() {
            return this.showError ? this.$t("globalDataModel.emptyElement") : "";
        },
        titleModal() {
            return this.isEditPermission
                ? this.$t("globalDataModel.editPermissions")
                : this.$t("globalDataModel.addPermission");
        },
        defaultAppValue() {
            return this.editDetails ? this.editDetails.value : "";
        }
    },
    watch: {
        searchAppValue: {
            handler(value) {
                if (value) {
                    const searchV = value.trim();
                    if (searchV && searchV.length > 2) {
                        this.appsPayload.page = 0;
                        this.searchAppsData(searchV);
                    }
                } else {
                    this.appsPayload.page = 0;
                    this.searchAppsData();
                }
            },
            immediate: true
        }
    },
    created() {
        this.addPermissionsModal = true;
        this.dataAccessValue = this.editDetails ? this.editDetails.access : "VIEW";
        this.viewDataAudit = this.editDetails ? this.editDetails.viewAudit : false;
    },
    deactivated() {
    },
    methods: {
        ...mapActions("apps", ["getPagedApps"]),
        actionsDlg($event) {
            if ($event === "primary") {
                this.selectedOption = true;
                if (!this.appsMod.length) {
                    this.showError = true;
                    this.selectedOption = false;
                    this.addPermissionsModal = true;
                } else {
                    this.addPermissionsModal = false;
                    this.showError = false;
                    this.selectedPermissions.access = this.dataAccessValue;
                    this.selectedPermissions.viewAudit = this.viewDataAudit;
                    this.selectedPermissions.permissionListModified = this.isEditPermission
                    && (this.dataAccessValue !== this.editDetails.access || this.viewDataAudit !== this.editDetails.viewAudit);
                    this.$emit("permissionsData", this.selectedPermissions);
                    this.$emit("input", false);
                }
            }
            if ($event === "close") {
                if (this.isEditPermission) {
                    this.selectedPermissions.permissionListModified = this.dataAccessValue !== this.editDetails.access
                    || this.viewDataAudit !== this.editDetails.viewAudit;
                } else {
                    this.selectedPermissions.permissionListModified = !!this.appsMod.length;
                }
                if (this.showError || this.selectedPermissions.permissionListModified) {
                    this.showDialog = true;
                } else {
                    this.$emit("input", false);
                    this.selectedOption = false;
                    this.$root.$off("openEditPermissions");
                }
            }
        },
        addPermission() {
            this.addPermissionModal = true;
        },
        hideAppsDDL() {
            this.searchAppValue = "";
        },
        searchAppsData(value, loadMore, fromScroll) {
            this.appsPayload.search = value || "";
            if (loadMore) {
                this.appsPayload.page++;
                this.getAllAppsOptions(loadMore, fromScroll);
            } else if (this.isEditPermission) {
                this.applicationsOptions = [{ label: this.editDetails.label, value: this.editDetails.value }];
            } else {
                this.getAllAppsOptions();
            }
        },
        getAllAppsOptions(load, fromScroll) {
            this.getPagedApps(this.appsPayload).then(data => {
                if (data.data.apps && data.data.apps.length) {
                    this.setAllAppsOptions(data.data.apps, load);
                } else if (!fromScroll) {
                    this.applicationsOptions = [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                }
            });
        },
        setAllAppsOptions(data, loadMore) {
            const appsList = data.map(elem => ({
                label: elem.name,
                value: elem.id,
                description: `${this.$t("apps.code")} ${elem.code}` || "N/A",
                imageUrl: elem.imageUrl
            }));
            appsList.sort((a, b) => {
                const classNameA = a.label.toLowerCase();
                const classNameB = b.label.toLowerCase();
                if (classNameA < classNameB) return -1;
                if (classNameA > classNameB) return 1;
                return 0;
            });
            if (loadMore) {
                this.applicationsOptions = this.applicationsOptions.concat(appsList);
            } else {
                this.applicationsOptions = [];
                this.applicationsOptions = appsList;
            }
        },
        showResults() {
            this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[1].$el;
            if (this.optionsMenu && this.optionsMenu.offsetHeight) {
                const checkSearch = this.optionsMenu.offsetHeight < 100;
                if (checkSearch) {
                    this.optionsMenu = this.$refs.applicationsRef.$refs.menuDropdown.$children[0].$children[0].$children[0].$el;
                }
            }
            this.optionsMenu.addEventListener("scroll", () => {
                if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop >= this.optionsMenu.scrollHeight && !this.searchAppValue) {
                    this.searchAppsData(null, true, true);
                }
            });
        },
        getSearchValue(value) {
            this.searchAppValue = value;
        },
        selectApp(data) {
            this.selectedOption = true;
            this.showError = false;
            [this.selectedPermissions] = data;
        },
        wrnAction(action) {
            if (action === "ok") {
                this.showDialog = false;
                this.addPermissionsModal = false;
                this.$emit("input", false);
            }
        }
    }
};
